import React from 'react';
import { useImpressionManager } from '@fiverr-private/impressionable';
import AssetsPage from '../../../pages/assets_sharing/components/AssetsPage';

const App = (props) => {
    useImpressionManager();

    return <AssetsPage {...props} />;
};

export default App;
